<template>
  <div class="deviceManagerCard">
    <b-card>
      <template #header>
        <h3 v-b-toggle="collapseUid" class="mb-0 custom-control">
          {{ title }}
        </h3>
      </template>
      <b-card-text>
        <b-collapse visible :id="collapseUid" class="mt-2">
          <TableView
            v-if="selectedTenant"
            title=""
            dataType="device"
            :index="selectedTenant.index"
            :controller="controller"
            :collection="collection"
            :add-item-label="addItemLabel"
            :include-global-index="includeGlobalIndex"
            :hide-create-action="hideCreateAction"
            :hide-edit-action="hideEditAction"
            :hide-delete-action="hideDeleteAction"
            :show-detach-action="showDetachAction"
            @attached="attached"
            @detached="detached"
            ref="tableView"
          >
          </TableView>
        </b-collapse>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import TableView from '@/components/device-manager/TableView';
import { ref } from '@vue/composition-api';

export default {
  components: {
    TableView
  },
  computed: {
    selectedTenant() {
      if (!this.includeGlobalIndex) {
        if (this.$store.getters['tenants/selectedTenant']) {
          return { index: this.$store.getters['tenants/selectedTenant'].index };
        }
        return null;
      }
      return { index: 'device-manager' };
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    controller: {
      type: String,
      required: true
    },
    collection: {
      type: String,
      required: true
    },
    addItemLabel: {
      type: String,
      required: false
    },
    includeGlobalIndex: {
      type: Boolean,
      required: false,
      default: false
    },
    hideCreateAction: {
      type: Boolean,
      required: false,
      default: false
    },
    hideEditAction: {
      type: Boolean,
      required: false,
      default: false
    },
    hideDeleteAction: {
      type: Boolean,
      required: false,
      default: false
    },
    showDetachAction: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(_, { emit }) {
    const tableView = ref(null);
    const collapseUid = (Date.now() + Math.random()).toString();

    return {
      collapseUid,
      tableView,
      attached: event => {
        emit('attached', event);
      },
      detached: event => {
        emit('detached', event);
      },
      fetchItems: async args => {
        await tableView.value.fetchItems(args);
      }
    };
  }
};
</script>

<style lang="css" scoped>
.tenant-selector {
  margin-top: 0.5em;
}

.deviceManagerCard {
  margin-top: 1em;
}

.custom-control:focus {
  outline: none !important;
}
</style>
